import React from "react";

const CartIcon = (props) => {
  const { height = "24", width = "24", color = "white" } = props;
  return (
    // <svg width={width} height={height} fill={color} viewBox='0 0 26 26'>
    //     <g transform='translate(2 2)' fill='none' fillRule='evenodd'>
    //         <path
    //             d='M3.312 3.115h19.244a1 1 0 0 1 .936 1.352l-3.93 10.462a1 1 0 0 1-.937.648H5.52L3.312 3.115z'
    //             fill={color}
    //         />
    //         <ellipse
    //             stroke={color}
    //             fill={color}
    //             cx='17.938'
    //             cy='21'
    //             rx='2.157'
    //             ry='2.5'
    //         />
    //         <ellipse
    //             stroke={color}
    //             fill={color}
    //             cx='8.969'
    //             cy='21'
    //             rx='2.157'
    //             ry='2.5'
    //         />
    //         <path
    //             stroke={color}
    //             strokeWidth='3'
    //             strokeLinecap='round'
    //             strokeLinejoin='round'
    //             d='M0 0h2.76l2.76 15.577-2.312 3.388H18.11'
    //         />
    //     </g>
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 154 113"
    >
      <path
        d="M131.552 68.987L144.668 25.883H37.9757L51.092 68.987H131.552ZM114.298 81.7582C118.769 81.7582 122.818 83.5069 125.747 86.3342C128.678 89.1614 130.491 93.0665 130.491 97.3791C130.491 101.692 128.678 105.598 125.747 108.424C122.817 111.251 118.769 113 114.298 113C109.828 113 105.779 111.251 102.849 108.424C99.9189 105.597 98.1061 101.692 98.1061 97.3791C98.1061 93.0665 99.9187 89.1604 102.849 86.3342C105.78 83.507 109.828 81.7582 114.298 81.7582ZM120.23 91.657C118.713 90.1938 116.613 89.2879 114.298 89.2879C111.984 89.2879 109.884 90.1938 108.367 91.657C106.85 93.1201 105.911 95.1406 105.911 97.3791C105.911 99.6123 106.85 101.638 108.367 103.101C109.884 104.564 111.984 105.47 114.298 105.47C116.613 105.47 118.713 104.564 120.23 103.101C121.747 101.638 122.686 99.6122 122.686 97.3791C122.686 95.146 121.747 93.1202 120.23 91.657ZM68.3426 81.7582C72.813 81.7582 76.862 83.5069 79.7915 86.3342C82.7222 89.1614 84.535 93.0665 84.535 97.3791C84.535 101.692 82.7223 105.598 79.7915 108.424C76.8609 111.251 72.813 113 68.3426 113C63.8723 113 59.8233 111.251 56.8938 108.424C53.9631 105.597 52.1503 101.692 52.1503 97.3791C52.1503 93.0665 53.9629 89.1604 56.8938 86.3342C59.8244 83.507 63.8723 81.7582 68.3426 81.7582ZM74.2741 91.657C72.7574 90.1938 70.6575 89.2879 68.3426 89.2879C66.0278 89.2879 63.928 90.1938 62.4112 91.657C60.8945 93.1201 59.9554 95.1406 59.9554 97.3791C59.9554 99.6123 60.8945 101.638 62.4112 103.101C63.9279 104.564 66.0278 105.47 68.3426 105.47C70.6575 105.47 72.7573 104.564 74.2741 103.101C75.7908 101.638 76.7298 99.6122 76.7298 97.3791C76.7298 95.146 75.7908 93.1202 74.2741 91.657ZM28.956 22.9102L24.2738 7.52963H4.7849C2.62944 7.52963 0.882324 5.84419 0.882324 3.76477C0.882324 1.68535 2.62941 -7.76543e-05 4.7849 -7.76543e-05H27.186V0.0094029C28.8719 0.0094029 30.4213 1.06912 30.9191 2.70504L35.681 18.3531H149.871V18.3626C150.237 18.3626 150.604 18.4121 150.969 18.5164C153.031 19.1011 154.214 21.1889 153.604 23.1787L138.276 73.5502C137.896 75.2452 136.336 76.5177 134.462 76.5177H48.1842V76.5082C46.4982 76.5082 44.9488 75.4485 44.451 73.8125L29.1224 23.441C29.0569 23.2736 29.0001 23.0966 28.963 22.9112L28.956 22.9102Z"
        fill={color}
      />
    </svg>
  );
};

export default CartIcon;
